import Container from '@/components/@base/container';
import CheckBox from '@/components/@base/input/check-box';
import { Text } from '@/components/@base/typography';
import localization from '@/constant/localization';
import { VouchersProps } from '@/components/vouchers-section/types';
import { calcDaysBetween2Date, currency, toMilliSecond } from '@/lib/helper';
import useHomeStore from '@/store/home';
import useUserWalletsVouchersStore from '@/store/user-wallets-store';
import useCommonModalStore from '@/store/common-modal-store';
import Button from '@/components/@base/button';
import { SIZE_ENUM } from '@/components/@base/@types';
import { usePostValidateSelections } from '@/services/hooks';
import { selectedSegments, selectedVouchers } from '@/services/models/api.models';
import AcceptSelection from '@/components/accept-selection';
import useBottomSheetStore from '@/store/bottom-sheet-store';
import cn from '@/lib/clsxm';
import mockVoucherLogo from '@/assets/mock-items/default-voucher-icon.svg';
import { useNavigate, useSearchParams } from 'react-router-dom';
import FontIcon from '@/components/@base/font-icon';
import { SegmentProps } from '@/components/wallets-section/types';
import { useState } from 'react';
const MoreUnusableVouchers = ({
  data,
  unUsable,
  disable = '',
  noBorderBottom,
  className
}: {
  data: VouchersProps;
  unUsable?: boolean;
  disable?: string;
  noBorderBottom?: boolean;
  className?: string;
}) => {
  const { setShowBottomSheet } = useBottomSheetStore();
  const { mutate: mutateValidation, isPending: pendingValidation } =
    usePostValidateSelections();
  const { remainInvoice, isActiveRequest, setIsActiveRequest } = useHomeStore();
  const { setShow } = useCommonModalStore();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isVoucherSelected, setIsVoucherSelected] = useState<boolean>(false);
  const {
    usableClientVouchers,
    setUsableClientVouchers,
    segments,
    setSegments,
    maximumConcurrentUseCount,
  } = useUserWalletsVouchersStore();
  const {
    discountPrice,
    discountTitle,
    expirationDate,
    upgLogo,
    voucherId,
    selected,
    isDisable,
    voucherRuleTypeTitle,
  } = data;
  const selectedVouchersLength = usableClientVouchers.filter((v) => v.selected)?.length;
  const isMaximumSelectionExceeded = maximumConcurrentUseCount
    ? selectedVouchersLength === maximumConcurrentUseCount
    : false;
  const handleClickOnVoucher = () => {
    setIsVoucherSelected(true);
    setTimeout(() => setIsVoucherSelected(false), 400);
    sessionStorage.setItem('isSelectedVoucherOrWallet', 'true');
    const selectedSegments: selectedSegments[] = [];
    segments?.map((s) => {
      if (s.selected) {
        selectedSegments.push({
          segmentId: s.segmentId,
          amount: s.usageBalance!,
        });
      }
    });
    const selectedVouchers: selectedVouchers[] = [];
    usableClientVouchers?.map((s) => {
      if (s.selected) {
        selectedVouchers.push({
          voucherId: s.voucherId,
        });
      }
    });
    if (isDisable || (isMaximumSelectionExceeded && !selected)) {
      mutateValidation(
        {
          selectedSegments: selectedSegments,
          lastSelectedSegment: {},
          notSelectedSegments: segments.filter((i) => !i.selected),
          lastSelectedVoucher: { voucherId: voucherId },
          selectedVouchers: selectedVouchers,
          notSelectedVouchers: usableClientVouchers
            .filter((i) => !i.selected)
            .filter((v) => v.voucherId !== voucherId),
        },
        {
          onSuccess: (res) => {
            if (res?.responseCode === 0) {
              setShow(true, {
                center: true,
                dialogPanelClassName: 'p-0 w-[90%] md:w-[380px]',
                Body: () => (
                  <Container center className='flex-col px-4 pb-4 pt-6'>
                    <img
                      src={data.upgLogo?.length > 0 ? data.upgLogo : mockVoucherLogo}
                      alt={data.voucherRuleTypeTitle}
                      className={cn('w-15 mb-4 h-10 rounded')}
                    />
                    <Text
                      className='mb-2 text-xl text-grayLight-1000 dark:text-grayLight-0'
                      semiBold
                    >
                      {data.voucherRuleTypeTitle}
                    </Text>
                    <Text className='mt-2 px-4 text-center text-[15px] leading-7 text-grayLight-850 dark:text-grayDark-300'>
                      {localization.assetCantSpendable(data.voucherRuleTypeTitle)}
                    </Text>
                    <Container className='my-4 w-full rounded-xl bg-grayLight-50 px-2 py-3 dark:bg-grayLight-850'>
                      {res?.lastSelectedAssetNotSpendableWithSelectedSegments?.map((s) => (
                        <Text className='flex items-center gap-1.5 text-grayLight-850 dark:text-grayDark-300'>
                          <span className='block h-1.5 w-1.5 rounded-full bg-grayLight-850 dark:bg-grayDark-300' />
                          {s.upgTitle}
                        </Text>
                      ))}
                      {res?.lastSelectedAssetNotSpendableWithSelectedVouchers?.map((v) => (
                        <Text className='flex items-center gap-1.5 text-grayLight-850 dark:text-grayDark-300'>
                          <span className='block h-1.5 w-1.5 rounded-full bg-grayLight-850 dark:bg-grayDark-300' />
                          {v.voucherRuleTypeTitle}
                        </Text>
                      ))}
                    </Container>
                    <Button
                      className='text-md h-12 w-full rounded-full'
                      onClick={() => setShow(false)}
                    >
                      {localization.iGetIt}
                    </Button>
                  </Container>
                ),
              });
            } else if (
              res?.responseCode === 5 ||
              res?.responseCode === 10 ||
              res?.responseCode === 15 ||
              res?.responseCode === 20
            ) {
              setShow(true, {
                center: true,
                dialogPanelClassName: 'p-0 w-[90%] md:w-[380px]',
                Body: () => (
                  <Container center className='flex-col px-4 pb-4 pt-6'>
                    <img
                      src={data.upgLogo?.length > 0 ? data.upgLogo : mockVoucherLogo}
                      alt={data.voucherRuleTypeTitle}
                      className={cn('w-15 mb-4 h-10 rounded')}
                    />
                    <Text
                      className='mb-2 text-xl text-grayLight-1000 dark:text-grayLight-0'
                      semiBold
                    >
                      {data.voucherRuleTypeTitle}
                    </Text>
                    <Text className='mb-4 mt-2 px-4 text-center text-[15px] leading-7 text-grayLight-850 dark:text-grayDark-300'>
                      {res?.responseCode === 5 &&
                        localization.SumSegmentAmountBiggerThanInvoiceAmount}
                      {res?.responseCode === 10 && localization.CombinationError}
                      {res?.responseCode === 15 &&
                        localization.voucherRuleTypeMaximumConcurrentUseCount}
                      {res?.responseCode === 20 &&
                        localization.InvoiceVoucherLimitationMaximumConcurrentUseCount}
                    </Text>
                    <Button
                      className='text-md h-12 w-full rounded-full'
                      onClick={() => setShow(false)}
                    >
                      {localization.iGetIt}
                    </Button>
                  </Container>
                ),
              });
            }
            setIsActiveRequest(false);
          },
          onError: () => {
            setIsActiveRequest(false);
          },
        },
      );
    } else if (!unUsable && !isActiveRequest) {
      setIsActiveRequest(true);
      const updatedSegments: SegmentProps[] = [];
      const selectedSegments: selectedSegments[] = [];
      segments?.map((s) => {
        if (s.selected) {
          selectedSegments.push({
            segmentId: s.segmentId,
            amount: s.usageBalance!,
          });
        }
      });
      if (
        remainInvoice > 0 &&
        !selected &&
        !pendingValidation &&
        !isMaximumSelectionExceeded
      ) {
        const selectedVouchers: selectedVouchers[] = [];
        const updatedVouchers: VouchersProps[] = [];
        usableClientVouchers?.map((s) => {
          if (s.selected) {
            selectedVouchers.push({
              voucherId: s.voucherId,
            });
          }
        });
        mutateValidation(
          {
            selectedSegments: selectedSegments,
            lastSelectedSegment: {},
            notSelectedSegments: segments.filter((i) => !i.selected),
            selectedVouchers: selectedVouchers,
            notSelectedVouchers: usableClientVouchers
              .filter((i) => !i.selected)
              .filter((i) => i.voucherId !== voucherId),
            lastSelectedVoucher: {
              voucherId: voucherId,
            },
          },
          {
            onSuccess: (res) => {
              if (res?.responseCode === 0) {
                segments?.map((s) => {
                  res.notSelectedSegmentsNotSpendable.map((ns) => {
                    if (s.segmentId === ns.segmentId) {
                      s.isDisable = true;
                    }
                  });
                  updatedSegments.push(s);
                });
                setSegments(updatedSegments);
                usableClientVouchers?.map((v) => {
                  if (v.voucherId === voucherId) {
                    v.selected = true;
                    v.usageBalance =
                      v.discountPrice >= remainInvoice ? remainInvoice : v.discountPrice;
                  }
                  res.notSelectedVouchersNotSpendable.map((ns) => {
                    if (v.voucherId === ns.voucherId) {
                      v.isDisable = true;
                    }
                  });
                  updatedVouchers.push(v);
                });
                setUsableClientVouchers(updatedVouchers);
              } else if (res?.responseCode === 5) {
                invoiceRemainderModal(
                  localization.biggerAmount,
                  localization.biggerVoucherAmountCaption,
                );
                setIsActiveRequest(false);
              } else if (res?.responseCode === 10 || res?.responseCode === 15) {
                // setChooseValidate(res);
                setShowBottomSheet(true, {
                  Body: () => <AcceptSelection />,
                });
              }
              setIsActiveRequest(false);
            },
            onError: () => {
              setIsActiveRequest(false);
            },
          },
        );
      } else if ((remainInvoice > 0 || selected) && !pendingValidation) {
        const selectedVouchers: selectedVouchers[] = [];
        const updatedVouchers: VouchersProps[] = [];
        usableClientVouchers?.map((s) => {
          if (s.selected) {
            selectedVouchers.push({
              voucherId: s.voucherId,
            });
          }
        });
        mutateValidation(
          {
            selectedSegments: selectedSegments,
            lastSelectedSegment: {},
            notSelectedSegments: segments.filter((i) => !i.selected),
            selectedVouchers: selectedVouchers.filter((i) => i.voucherId !== voucherId),
            notSelectedVouchers: usableClientVouchers.filter((i) => !i.selected),
            lastSelectedVoucher: {},
          },
          {
            onSuccess: (res) => {
              if (res?.responseCode === 0) {
                segments?.map((s) => {
                  s.isDisable = false;
                  res.notSelectedSegmentsNotSpendable.map((ns) => {
                    if (s.segmentId === ns.segmentId) {
                      s.isDisable = true;
                    }
                  });
                  updatedSegments.push(s);
                });
                setSegments(updatedSegments);
                usableClientVouchers?.map((v) => {
                  if (v.voucherId === voucherId) {
                    if (selected) {
                      v.selected = !v.selected;
                      v.usageBalance = 0;
                    }
                  } else v.isDisable = false;
                  res.notSelectedVouchersNotSpendable.map((ns) => {
                    if (v.voucherId === ns.voucherId) {
                      v.isDisable = true;
                    }
                  });
                  updatedVouchers.push(v);
                });
                setUsableClientVouchers(updatedVouchers);
              }
              setIsActiveRequest(false);
            },
            onError: () => {
              setIsActiveRequest(false);
            },
          },
        );
      } else if (remainInvoice === 0) {
        invoiceRemainderModal(localization.zeroAmount, localization.zeroVoucherAmountCaption);
        setIsActiveRequest(false);
      }
    }
  };
  const invoiceRemainderModal = (title: string, text: string) => {
    navigate(`/?pgc=${searchParams.get('pgc')}&mt=invoice-remain-is-zero`);
    const closeModal = () => {
      setShow(false);
      navigate(`/?pgc=${searchParams.get('pgc')}`);
    };
    setShow(true, {
      center: true,
      dialogPanelClassName: 'p-0 w-[90%] md:w-[380px]',
      Body: () => (
        <Container center className='flex-col pt-6'>
          <Container center className='mb-6 h-[56px] w-[56px] rounded-full bg-green-50'>
            <FontIcon icon='icon-check' className='text-3xl text-green' />
          </Container>

          <Text className='mb-2 text-xl text-grayLight-1000 dark:text-grayLight-0' semiBold>
            {title}
          </Text>
          <Text className='mb-6 mt-2 px-4 text-center text-[15px] leading-7 text-grayLight-850 dark:text-grayDark-300'>
            {text}
          </Text>
          <Container className='w-full p-4'>
            <Button className='text-md h-12 w-full rounded-full' onClick={closeModal}>
              {localization.iGetIt}
            </Button>
          </Container>
        </Container>
      ),
    });
  };

  const checkShowInfo = () => {
    if (!selected && isMaximumSelectionExceeded) {
      return true;
    } else if (isDisable && !isMaximumSelectionExceeded) {
      return true;
    }
  };
  return (
    <Container
      center
      className={cn(
        'relative min-h-[88px] w-full border-b-2 border-grayLight-0 bg-grayLight-50 pl-[22px] last:border-none dark:border-grayLight-990 dark:bg-grayDark-750',
        !unUsable && 'cursor-pointer',
        !isMaximumSelectionExceeded && !selected && 'cursor-pointer',
        unUsable && 'rounded-xl py-3',
        isVoucherSelected && 'blink-500',
        className,
      )}
      onClick={handleClickOnVoucher}
    >
      {pendingValidation && <Container className='state-changed z-10' />}
      {/*{(isMaximumSelectionExceeded && !selected) || isDisable && <Container className='gray-overlay z-20' />}*/}
      {upgLogo && upgLogo?.length > 0 && (
        <img
          src={upgLogo}
          alt=''
          className={cn(
            'w-15 ml-3 mr-3 h-10 rounded md:mr-6',
            isMaximumSelectionExceeded && !selected && 'gray-scale',
            !!disable && 'opacity-50 grayscale',
          )}
        />
      )}
      {(!upgLogo || upgLogo?.length === 0) && (
        <img
          src={mockVoucherLogo}
          alt=''
          className={cn(
            'w-15 ml-3 mr-3 h-10 rounded md:mr-6',
            isMaximumSelectionExceeded && !selected && 'gray-scale opacity-50',
            !!disable && 'grayscale',
            isDisable && 'opacity-50 grayscale',
          )}
        />
      )}
      <Container
        center
        className={cn(
          'h-full min-h-[88px] w-full justify-between pl-4',
          noBorderBottom && 'border-none',
        )}
      >
        <Container className='flex flex-col items-start gap-1'>
          {discountPrice === 0 && !disable ? (
            <Text
              size={SIZE_ENUM.MD}
              className='text-grayLight-1000 dark:text-grayLight-0'
              medium
            >
              {localization.scoreVoucher}
            </Text>
          ) : !!disable ? (
            <Text className='text-sm text-grayLight-1000 dark:text-grayLight-0'>
              {voucherRuleTypeTitle}
            </Text>
          ) : (
            <Text
              className={cn(
                'text-md text-grayLight-1000 dark:text-grayLight-0',
                (isDisable || (isMaximumSelectionExceeded && !selected)) &&
                  '!text-grayLight-650',
              )}
              medium
            >
              {currency(discountPrice)} <span className='text-xs'>{localization.rial}</span>
            </Text>
          )}
          {unUsable && (
            <Container
              center
              className='mt-2 w-fit gap-1 rounded-md border border-yellow-500 bg-yellow-50 px-2 py-0 dark:bg-yellow-900'
            >
              <Text className='text-yellow-500 dark:text-yellow-300'>{disable}</Text>
              <FontIcon
                icon='icon-circle-information'
                className='text-yellow-500 dark:text-yellow-300'
              />
            </Container>
          )}
          {!unUsable && (
            <Container center className='gap-[6px]'>
              {!!disable ? (
                <Text className='text-[12px] text-grayLight-600 dark:text-grayDark-300'>
                  {localization.remainExpiration(
                    calcDaysBetween2Date(toMilliSecond(expirationDate)),
                  )}
                </Text>
              ) : (
                <Text
                  className={cn(
                    'text-[12px] text-grayLight-600 dark:text-grayDark-300',
                    (isDisable || (isMaximumSelectionExceeded && !selected)) &&
                      '!text-grayLight-650',
                  )}
                >
                  {`${voucherRuleTypeTitle}  •  ${localization.remainExpiration(calcDaysBetween2Date(toMilliSecond(expirationDate)))}`}
                </Text>
              )}
            </Container>
          )}
        </Container>
      </Container>
      {checkShowInfo() && (
        <FontIcon
          icon='icon-circle-information'
          className='ml-2 text-xl text-grayLight-25 dark:text-grayLight-750'
        />
      )}
      {!unUsable && (
        <CheckBox
          checked={selected}
          isDisable={isDisable || (isMaximumSelectionExceeded && !selected)}
        />
      )}
    </Container>
  );
};

export default MoreUnusableVouchers;
